import { dictionary } from "@/schemas/dictionary";
import { z } from "@/zod";
import { ulid, projectDependsOn } from "@/schemas/commonFields";

const projectTypeServicesAndGoods = z.object({
  services_and_goods_id: ulid.optional(),
  services_and_goods: z.string().optional(),
  services_and_goods_code: z.string().optional(),
});

const projectType = dictionary
  .extend({
    description: z.string().max(250).optional(),
    project_depends_on: projectDependsOn,
    available_for_structure: z.boolean().optional(),
  })
  .extend(projectTypeServicesAndGoods.shape);

export const readProjectType = projectType.readonly();
export const readProjectTypeServicesAndGoods =
  projectTypeServicesAndGoods.readonly();

export const createProjectType = projectType.omit({
  id: true,
  services_and_goods_code: true,
  services_and_goods: true,
});

export const updateProjectType = createProjectType.omit({
  project_depends_on: true,
});
